export function formatDateTime(date: Date): string {
  return date.toLocaleString();
}
